import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getExclusionsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query !== undefined
        ? apiUrl + "/opa-exclusion-categories" + actions.query
        : actions.page !== undefined
          ? apiUrl + "/opa-exclusion-categories" + actions.page
          : apiUrl + "/opa-exclusion-categories";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: error });
  }
}

function* createExclusionsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-exclusion-categories";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);


    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "CREATE_EXCLUSIONS_CATEGORY_RESPONSE", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "CREATE_EXCLUSIONS_CATEGORY_RESPONSE", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

// New Sagas for Product-Specific Exclusions

function* getProductExclusionsCategory(actions) {
  let realmUuid = getSetCookie(); // realmUuid instead of uuid for clarity
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": realmUuid,
    };

    const requestOptions = {
      headers: headers,
    };

    // Assuming the endpoint for product-specific exclusions follows a similar pattern to inclusions
    let url = apiUrl + "/opa-product-exclusion/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "GET", url, requestOptions);


    yield put({ type: "LIST_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: { ...error, responseStatus: "error" } });
  }
}

function* updateProductExclusionsCategory(actions) {
  let realmUuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": realmUuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-exclusion/" + actions.productUuid + "/" + actions.exclusionCategoryUuid;


    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      // Assuming a successful update returns the updated object, possibly with 'updatedAt' or similar
      // Adjust this condition based on your actual API response for a successful PATCH
      if (response.uuid || response.id || response.name) { // More robust check for success
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    } else {
      responseStatus = "error"; // If response is null/undefined
    }

    yield put({ type: "UPDATE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE", value: { ...response, responseStatus } });

  } catch (error) {
    yield put({ type: "UPDATE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE", value: { ...error, responseStatus: "error" } });
  }
}

function* deleteProductExclusionsCategory(actions) {
  let realmUuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": realmUuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-exclusion/" + actions.productUuid + "/" + actions.exclusionCategoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "DELETE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: { ...response, responseStatus } });
  } catch (error) {
    yield put({ type: "DELETE_PRODUCT_EXCLUSIONS_CATEGORY_RESPONSE_GET", value: { ...error, responseStatus: "error" } });
  }
}

function* createProductExclusionsCategory(actions) {
  let realmUuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": realmUuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };


    let url = apiUrl + "/opa-product-exclusion/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.uuid || response.id || response.name) { // Check for fields indicating success (e.g., uuid of the new mapping or category)
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    } else {
      responseStatus = "error";
    }
    yield put({ type: "CREATE_PRODUCT_EXCLUSION_CATEGORY_RESPONSE", value: { ...response, responseStatus } });

  } catch (error) {
    yield put({ type: "CREATE_PRODUCT_EXCLUSION_CATEGORY_RESPONSE", value: { ...error, responseStatus: "error" } });
  }
}

export function* getSagaExclusionsCategoryList() {
  yield takeEvery("GET_LIST_EXCLUSIONS_CATEGORY", getExclusionsCategory);
}

// Saga for creating general exclusion categories (remains as is if still needed for general admin)
export function* createSagaExclusionsCategory() {
  yield takeEvery("CREATE_PRODUCT_EXCLUSIONS_CATEGORY", createExclusionsCategory);
}

// New watcher sagas for product-specific exclusion categories
export function* getSagaProductExclusionsCategoryList() {
  yield takeEvery("GET_PRODUCT_LIST_EXCLUSIONS_CATEGORY", getProductExclusionsCategory);
}

export function* updateSagaProductExclusionsCategory() {
  yield takeEvery("UPDATE_PRODUCT_EXCLUSIONS_CATEGORY", updateProductExclusionsCategory);
}

export function* deleteSagaProductExclusionsCategory() {
  yield takeEvery("DELETE_PRODUCT_EXCLUSIONS_CATEGORY", deleteProductExclusionsCategory);
}

// New watcher for product-specific exclusion category creation
export function* createSagaProductExclusionsCategory() {
  yield takeEvery("CREATE_PRODUCT_EXCLUSIONS_CATEGORY", createProductExclusionsCategory);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
